export default __webpack_public_path__ + "static/media/logo.01fc9b26.svg";